import SearcherContainer from "pages/SearcherContainer";
import { Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import "react-loading-skeleton/dist/skeleton.css";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import LoaderComponent from "./components/UI/loader";
import { LANDING_ROUTES, SportCentersRoutes } from "./routes";
const isForSportCenter = !!process.env.REACT_APP_CENTER_KEY;
function App() {
  return (
    <HelmetProvider>
      <Suspense fallback={<LoaderComponent />}>
        <BrowserRouter>
          <Switch>
            {LANDING_ROUTES.map((route, index) => (
              <Route key={index} path={route.path} exact={route.exact}>
                <route.component />
              </Route>
            ))}
            {!isForSportCenter ? (
              <Route path="/searcher" component={SearcherContainer} />
            ) : (
              SportCentersRoutes.map((route, index) => (
                <Route key={index} path={route.path} exact={route.exact}>
                  <route.component />
                </Route>
              ))
            )}
            <Redirect to="/" />
          </Switch>
        </BrowserRouter>
      </Suspense>
    </HelmetProvider>
  );
}

export default App;
